var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.07,10.59c0-3.159-2.888-5.642-6.168-4.955-1.965.412-3.528,2.035-3.887,4.01-.321,1.77.282,3.398,1.402,4.512.922.916,1.359,2.214,1.359,3.513h0s4.458,0,4.458,0h0c0-1.3.43-2.601,1.351-3.518.916-.912,1.485-2.167,1.485-3.563Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.132,10.205c-.295-1.497-1.572-2.641-3.132-2.733"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.771,
    y1: 19.525,
    x2: 14.229,
    y2: 19.525
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.797,
    y1: 21.38,
    x2: 13.203,
    y2: 21.38
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3.554,
    x2: 12,
    y2: 2.62
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.934,
    y1: 5.653,
    x2: 6.274,
    y2: 4.992
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4.836,
    y1: 10.718,
    x2: 3.902,
    y2: 10.718
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20.098,
    y1: 10.718,
    x2: 19.164,
    y2: 10.718
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 17.726,
    y1: 4.992,
    x2: 17.066,
    y2: 5.653
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 4.836,
    y1: 10.718,
    x2: 3.902,
    y2: 10.718
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 20.098,
    y1: 10.718,
    x2: 19.164,
    y2: 10.718
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.f3829268bfc0cc66d1fb3cc6e42d9e11.svg";
export { ForwardRef as ReactComponent };